import React from "react";
import { useHistory } from "react-router-dom";
import {Button, Grid} from 'semantic-ui-react';


const TopHeader = ({logo}) => {
    let history = useHistory();
    const handleReconcilationClick = () =>{
        window.location.reload();
        }
    return (
        <>
            <Grid.Column>
                <img src={logo} className="recon-TopHeaderLogo"/>
            </Grid.Column>
            <Grid.Column textAlign="right" className="recon-TopHeaderButtons">
                <Button compact className="recon-button" onClick={handleReconcilationClick}>RECONCILIATION</Button>
                <Button compact className="recon-button" onClick={() => history.push("")}>BROKER</Button>
            </Grid.Column>
        </>
    )
}
 
export default TopHeader;